import useSWR from "swr";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ApiError, apiGet, login } from "./api";
import { AdminShell } from "./AdminShell";
import { CitiesPage } from "./pages/CitiesPage";
import { DataBrowserPage } from "./pages/DataBrowserPage";
import { LoginPage } from "./pages/LoginPage";
import { RunDetailPage } from "./pages/RunDetailPage";
import { RunsPage } from "./pages/RunsPage";

const fetcher = <T,>(path: string) => apiGet<T>(path);

export default function App() {
  const { error, mutate } = useSWR("/admin/api/health", fetcher);
  if (error instanceof ApiError && error.status === 401) {
    return <LoginPage onLogin={(password) => login(password).then(() => mutate())} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AdminShell />}>
          <Route path="/" element={<Navigate to="/cities" replace />} />
          <Route path="/cities" element={<CitiesPage />} />
          <Route path="/cities/:slug" element={<CitiesPage />} />
          <Route path="/runs" element={<RunsPage />} />
          <Route path="/runs/:id" element={<RunDetailPage />} />
          <Route path="/data" element={<DataBrowserPage />} />
          <Route path="*" element={<Navigate to="/cities" replace />} />
        </Route>
      </Routes>
      <Toaster richColors position="bottom-right" />
    </BrowserRouter>
  );
}
